<div class="partner-wrapper">
  <div class="hero card-glass mb-4">
    <div class="crumb">
      <a routerLink="/utilisateur/partenaire/dashboard" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au dashboard partenaire</a>
    </div>
    <p class="eyebrow">Spay · Partenaire</p>
    <h1 class="text-success fw-bolder">Dépôt sur compte</h1>
    <p class="lead">Créditez un compte personnel ou professionnel et suivez ses indicateurs.</p>
  </div>

  <div class="row g-3">
    <div class="col-lg-5">
      <div class="card card-glass h-100 p-3">
        <h5 class="mb-3">Effectuer un dépôt</h5>
        <div class="alerts mb-2">
          <p *ngIf="succesmessageDepot" class="alert-text success">La transaction a été effectuée.</p>
          <p *ngIf="errorD1" class="alert-text danger">Compte introuvable.</p>
          <p *ngIf="errorD3" class="alert-text danger">Montant non autorisé.</p>
          <p *ngIf="errorD4" class="alert-text danger">Montant invalide.</p>
          <p *ngIf="errorD11" class="alert-text warning">Montant sensible: répétez exactement l'opération pour
            confirmer.</p>
          <p *ngIf="errorD12" class="alert-text danger">Code opérationnel invalide.</p>
          <p *ngIf="errorD13" class="alert-text danger">Décomposition des billets requise.</p>
          <p *ngIf="errorD14" class="alert-text danger">Le total des billets ne correspond pas au montant saisi.</p>
        </div>
        <form [formGroup]="deposit" #f="ngForm" (ngSubmit)="makeDeposit(f.value)" class="row g-3">
          <div class="col-md-12">
            <label class="form-label">Numéro de compte</label>
            <input formControlName="account" name="compte" type="text" class="form-control" placeholder="numéro compte"
              #account (blur)="checkAccount(account.value)" required>
            <small *ngIf="account.invalid  && (account.dirty || account.touched)" class="text-danger">Numéro de compte
              invalide</small>
          </div>
          <div class="col-md-12">
            <label class="form-label">Montant</label>
            <input type="number" formControlName="montan" name="montan" class="form-control" id="montan"
              placeholder="Montant du dépôt">
          </div>
          <div class="col-md-12">
            <label class="form-label">Code opérationnel employé</label>
            <input type="text" formControlName="supervisorCode" name="supervisorCode" class="form-control"
              placeholder="Code opérationnel employé">
            <small class="text-muted">Matricule: {{ matriculeEmploye || 'N/A' }}</small>
          </div>
          <div class="col-12">
            <label class="form-label">Décomposition billets (obligatoire)</label>
          </div>
          <div class="col-md-4">
            <label class="form-label">10 000</label>
            <input type="number" min="0" formControlName="d10000" class="form-control">
          </div>
          <div class="col-md-4">
            <label class="form-label">5 000</label>
            <input type="number" min="0" formControlName="d5000" class="form-control">
          </div>
          <div class="col-md-4">
            <label class="form-label">2 000</label>
            <input type="number" min="0" formControlName="d2000" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-label">1 000</label>
            <input type="number" min="0" formControlName="d1000" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-label">500</label>
            <input type="number" min="0" formControlName="d500" class="form-control">
          </div>
          <div class="col-12 d-grid">
            <button type="submit" class="btn btn-primary btn-pill" [disabled]="!deposit.valid || isSubmittingDepot">
              {{ isSubmittingDepot ? 'Traitement...' : 'Effectuer' }}
            </button>
          </div>
        </form>

        <div class="metrics mt-4">
          <h6 class="mb-2">Situation du compte</h6>
          <div class="metric-row" *ngFor="let m of [
            {label:'Solde du compte', value: soldeMensuel},
            {label:'Total dépôts', value: totalDepots},
            {label:'Total retrait', value: totalRetrait}
          ]">
            <span>{{m.label}}</span>
            <strong>{{m.value | currency:'FCFA'}}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-7">
      <div class="card card-glass p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Synthèse mensuelle</h5>
        </div>
        <div class="row g-3" *ngIf="depotMensualite?.length; else noData">
          <div class="col-sm-6 col-xl-4" *ngFor="let m of depotMensualite">
            <div class="mini-card">
              <div class="mini-card-header">
                {{ m.month }}/{{ m.annee }}
              </div>

              <div class="mini-card-body">
                <div class="metric-row">
                  <span>Solde du mois</span>
                  <strong>{{ m.soldeMensuel | number:'1.0-0' }} {{ sigle }}</strong>
                </div>

                <div class="metric-row">
                  <span>Total dépôt</span>
                  <strong>{{ m.depot + m.depotClient | number:'1.0-0' }} {{ sigle }}</strong>
                </div>

                <!--<div class="metric-row">
                  <span>Bénéfice dépôt</span>
                  <strong>{{ m.bDepot | number:'1.0-0' }} {{ sigle }}</strong>
                </div>-->

                <div class="metric-row">
                  <span>Total retrait</span>
                  <strong>{{ m.retrait | number:'1.0-0' }} {{ sigle }}</strong>
                </div>

                <!--<div class="metric-row">
                  <span>Bénéfice retrait</span>
                  <strong>{{ m.bRetrait | number:'1.0-0' }} {{ sigle }}</strong>
                </div>-->
              </div>
            </div>
          </div>
        </div>


        <ng-template #noData>
          <div class="text-muted text-center py-4">
            Aucune donnée mensuelle disponible
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>
